export default __webpack_public_path__ + "static/media/masterplan.277f9d64.webp";